export default __webpack_public_path__ + "static/media/connchecker.30667411.svg";